import storage from 'local-storage-fallback';

export const rememberMePreset = () => { 
    if (storage.getItem('rememberMe') === null) {
        storage.setItem('rememberMe', 'true');
    }
    return storage.getItem('rememberMe') === 'true';
};

export default storage;